import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { AccountDefiningModel, DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { PurchaseDetailViewModel } from 'src/app/viewmodels/g-purchase/PurchaseDetailViewModel';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { G_WareHouseViewModel } from 'src/app/viewmodels/g-settings/G_Warehouse_Viewmodel';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { PurchaseDetailModel, SavePurchaseMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { SaveItemRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { E_G_EPSStatusType } from 'src/app/viewmodels/g-purchase/E_G_EPSStatusType';
@Component({
  selector: 'app-purchase-form',
  templateUrl: './purchase-form.component.html',
  styleUrls: ['./purchase-form.component.scss']
})
export class PurchaseFormComponent implements OnInit {

  @Input() public vm: SavePurchaseMasterRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  modalRef: BsModalRef;
  private submitted = false;
  public component_Title = 'Purchase';
  public isPreview: boolean = false;
  public thumbnail: any;
  public nowDate: Date;
  public ComName: any;
  public Address: any;
  public contect: any;

  public defaultDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'refId',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'accTitle',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };

  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public sparePartVm: SaveItemRequest = new SaveItemRequest();
  public citemtype = 'itemtype';
  public itemTypes: any = [];

  public suppliers: any = [];
  public csuppliers = 'suppliers';
  public selectedSuppliers: any = [];

  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectspp: any;
  public wareHouseList: Array<any> = [];
  public whList: Array<any> = [];
  public purchaseRequisitions: any = [];
  public cpurchaseRequisitions = 'purchaseRequisitions';
  public selectedPurchaseRequisitions: any = [];
  public client: any;
  public user: any;
  public file: any;
  public uploadFlag: boolean = false;
  public purchaseImport: any = [];
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService
  ) { }
  name = 'cpEmail';
  id = 'id';
  checked = true;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';
  ngOnInit() {
    debugger
    this.client = this._localStorageService.get("com");
    this.user = this._localStorageService.get("ussr");
    this.isPreview = false;
    this.getimage();
    if (this.vm == undefined) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.transactionDate = new Date();
      this.vm.paymentType = 1;
      this.vm.purchaseDetail = [];
      this.vm.vatValue = parseInt(this.client.Vat);
      this.selectedSpareParts = [];
      this.selectedPurchaseRequisitions = [];
      this.vm.supCreditAccEmail = new ItemViewModel1(0, "");
      this.getRefid();

    } else {
      let selectedSuplier: any = [];
      let selectedSaprePartsList: any = [];
      let selectedemail: any;
      if (this.vm.supCreditAcc != undefined && this.vm.supCreditAcc != null) {
        let sCA = new AccountDefiningModel();
        sCA.id = this.vm.supCreditAcc.id;
        sCA.accTitle = this.vm.supCreditAcc.name;
        if (this.vm.supCreditAccEmail != undefined && this.vm.supCreditAccEmail != null) {
          sCA.id = this.vm.supCreditAccEmail.id;
          sCA.cpEmail = this.vm.supCreditAccEmail.name;
        }
        selectedSuplier.push(sCA);
        this.selectedSuppliers = selectedSuplier;
        this.selectspp = selectedemail;
        this.vm.supCreditAcc = new ItemViewModel1(this.vm.supCreditAcc.id, this.vm.supCreditAcc.name);
        //this.vm.Vat_Value=5;
      }
      this.vm.purchaseDetail.forEach(x => {
        let partssSelected = new SaveItemRequest();
        partssSelected.id = x.item.id;
        partssSelected.name = x.item.name;
        selectedSaprePartsList.push(partssSelected);
      });
      this.selectedSpareParts = selectedSaprePartsList;
      this.updateTotals();
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Purchase Order';
    }
    this.sparePartVm = new SaveItemRequest();
    this.sparePartVm.itemType = new ItemViewModel1(0, ' ');
    //this.vm.Vat_Value = 15;
    this.nowDate = new Date();

    this.getWareHouses();
    this.getItemTypes();
    this.getSuppliers();
    this.getRequisitions();
    this.getSpareParts();
    this.vatChanged();

  }

  onChange(e) {
    debugger
    if (this.selectedSuppliers.length > 0) {
      let item = this.selectspp;
      if (e == true) {
        if (this.selectedSuppliers.length > 0 && this.suppliers != undefined) {
          let findSelected = this.suppliers.find(x => x.id == this.selectedSuppliers[0].id);
          let i = new SavePurchaseMasterRequest();
          this.vm.supCreditAccEmail = new ItemViewModel1(findSelected.id, findSelected.cpEmail);
          this.vm.isEmailRequired = true;
        }
      }
    } else {
      this.vm.supCreditAccEmail = new ItemViewModel1(0, "");
      this.vm.isEmailRequired = false;
    }
  }

  getRefid() {
    this._uow.gPurchaseService.GetGPurchaseRefIdAsync().subscribe(
      (res: any) => {
        console.log(res);
        this.vm.refId = res.code;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  getSuppliers() {

    let supllier = AppConsts.SUPPLIER;
    if (this.vm.paymentType === 2) {
      supllier = "Cash";
    }
    this._uow.gSettingService.GetGCustomersDropDownAsync(supllier).subscribe((res: any) => {

      this.suppliers = res.result;
      this._uow.logger.log(this.suppliers);
    }, (err) => this._uow.logger.log(err));
  }

  getItemTypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => {
      this.itemTypes = res.result;
      console.log(res);
    }, (err) => this._uow.logger.log(err));
  }

  getWareHouses() {
    this._uow.gSettingService.GetUserWarehouseAsync(this.user.Id).subscribe(
      (res: any) => {
        debugger
        this.wareHouseList = res.result;
        this.whList = res.result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequisitions() {
    this._uow.gSettingService.GetPurchaseRequisiteDropDownAsync().subscribe(
      (res: any) => {
        this.purchaseRequisitions = res.result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getSpareParts() {
    //'Spare-Parts'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync("Spare-Parts").subscribe(
      (res: any) => {
        this.spareParts = res.result;
        console.log(res);
      },
      (err) => {
        this._uow.logger.log(err);
        this.spareParts = [];
      }
    );
  }

  vatChanged() {
    debugger
    if (this.vm.vatValue > -1) {
      if (this.vm.purchaseDetail !== undefined && this.vm.purchaseDetail.length > 0) {
        this.vm.purchaseDetail.forEach(x => {
          x.vatValue = this.vm.vatValue;
          x.vatAmount = ((x.totalAmount / 100) * this.vm.vatValue);
        });
      }
      this.updateTotals();
    }
  }

  onclick(event) {
    event.target.value = '';
    this.file = undefined;
  }
  attachfile(event) {
    if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      event.target.files[0].Name = '';
      this.uploadFlag = true;
      return;
    }
    else {
      this.uploadFlag = false;
      this.file = event.target.files[0];
    }
    console.log(event.target.files[0]);
    // event.target.files[0]
  }

  uploadExcel() {
    debugger
    this._uow.gPurchaseService.GetPurchaseImportAsync(this.file).subscribe((res: any) => {
      debugger
      this.purchaseImport = res.result;
      let selectedSaprePartsList: any = [];
      for (let x = 0; x < this.purchaseImport.length; x++) {
        let item = this.spareParts.find(s => s.code === this.purchaseImport[x].code);
        console.log(item);
        if (item !== undefined) {
          let i = new PurchaseDetailModel();
          i.quantity = this.purchaseImport[x].quantity;
          i.item = new ItemViewModel1(item.id, item.name);
          i.maxQuantity = item.maxStock;
          i.availabelQuantity = item.currentStock;
          //i.quantity = item.maxStock - item.currentStock;
          if (item.currentStock > item.maxStock) {
            i.quantity = 0;
          }
          i.itemCode = item.code;
          i.itemName = item.name;
          //i.purchasePrice = item.purchasePrice;
          i.purchasePrice = this.purchaseImport[x].rate;
          i.salePrice = item.salePrice;
          i.itemType = item.itemType.name;
          i.vatAmount = 0;
          i.vatValue = parseInt(this.client.Vat);
          this.quantityOrPriceChanged(i);
          this.vm.purchaseDetail.push(i);
          this.vatChanged();
          this.updateTotals();


          let partssSelected = new SaveItemRequest();
          partssSelected.id = item.id;
          partssSelected.name = item.name;
          selectedSaprePartsList.push(partssSelected);


        }
        else{
           Swal.fire(
          'Failure!',
           'Your item not found' +' '+ this.purchaseImport[x].code,
          'error'
        )
        }
      }
      this.selectedSpareParts = selectedSaprePartsList;
    });
  }



  getSupCashList() {
    this.selectedSuppliers = [];
    this.getSuppliers();
  }

  PaymentTypeChanged() {

  }

  // spare parts
  onSelectSparePart(e) {
    debugger
    console.log(e);
    if (this.vm.purchaseDetail == undefined || this.vm.purchaseDetail.length == 0) {
      this.vm.purchaseDetail = [];
    }
    let item = this.spareParts.find(x => x.id === e.id);
    console.log(item);
    if (item !== undefined) {
      let i = new PurchaseDetailModel();
      i.quantity = 1;
      i.item = new ItemViewModel1(item.id, item.name);
      i.maxQuantity = item.maxStock;
      i.availabelQuantity = item.currentStock;
      i.quantity = item.maxStock - item.currentStock;
      if (item.currentStock > item.maxStock) {
        i.quantity = 0;
      }
      i.itemCode = item.code;
      i.itemName = item.name;
      i.purchasePrice = item.purchasePrice;
      i.salePrice = item.salePrice;
      i.itemType = item.itemType.name;
      i.vatAmount = 0;
      i.vatValue = parseInt(this.client.Vat);
      this.quantityOrPriceChanged(i);
      this.vm.purchaseDetail.push(i);
      this.vatChanged();
      this.updateTotals();

    }

  }

  onDeSelectSparePart(e) {
    let i = this.vm.purchaseDetail.find(x => x.item.id === e.id);
    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
    }
    this.updateTotals();
  }

  onSelectSupplier(e) {
    let item = this.suppliers.find(x => x.id === e.id);
    console.log(item);
    if (item !== undefined) {
      let i = new SavePurchaseMasterRequest();
      this.vm.supCreditAcc = new ItemViewModel1(item.id, item.accTitle);
      this.selectspp = item;
      //this.vm.FK_Sup_Cradit_Acc.Id = item.Id;
      //this.vm.FK_Sup_Cradit_Acc.Name = item.Acc_Titel;
    }
  }


  // input changes
  quantityOrPriceChanged(m) {
    m.totalAmount = m.quantity * m.purchasePrice;
    this.vatChanged();
    this.updateTotals();
  }



  vatAmountChanged(m) {
    this.updateTotals();
  }

  public TotalPayable = 0;
  public TotalVat = 0;
  public TotalPayableAfterVat = 0;
  updateTotals() {
    debugger
    this.TotalPayableAfterVat = 0;
    this.TotalVat = 0;
    this.TotalPayable = 0;
    if (this.vm.purchaseDetail !== undefined && this.vm.purchaseDetail.length > 0) {
      this.vm.purchaseDetail.forEach(x => {
        this.TotalPayable += x.totalAmount;
        this.TotalVat += x.vatAmount;
        this.TotalPayableAfterVat += (x.totalAmount + x.vatAmount);
        this.vm.invAmount = this.TotalPayableAfterVat;
      });
    }
  }

  // purchase requisition change
  onSelectPurchaseRequisition(e) {
    debugger
    let selectedSaprePartsList: any = [];
    let selectedSuplier: any = [];
    let selectedWareHouseList: any = [];
    let f = this.purchaseRequisitions.find(x => x.id == e.id);
    if (f !== undefined) {
      console.log('selected purchase order', f);
      let s = f;
      //this.vm = new G_PurchaseMasterViewModel();
      this.vm = s;
      // this.vm.FK_WareHouse_Id=s.Fk_WareHouse_Id;
      this.vm.wareHouse = new ItemViewModel1(s.wareHouse.id, s.wareHouse.name);
      this.vm.isLinked = true;
      this.vm.invAmount = this.TotalPayableAfterVat;
      this.vm.transactionDate = this._uow.defaultService.CutTimeZone(f.transactionDate);
      this.vm.paymentType = 1;
      this.vm.vatValue = parseInt(this.client.Vat);
      if (s.wareHouse != null && s.wareHouse != undefined) {
        this.vm.wareHouse = new ItemViewModel1(s.wareHouse.id, s.wareHouse.name);

        selectedWareHouseList.push({ wareHouse: this.vm.wareHouse });
        this.wareHouseList = selectedWareHouseList;
      }
      if (f.supCreditAcc != undefined && f.supCreditAcc != null) {
        let sCA = new AccountDefiningModel();
        sCA.id = f.supCreditAcc.id;
        sCA.accTitle = f.supCreditAcc.name;
        selectedSuplier.push(sCA);
        this.selectedSuppliers = selectedSuplier;
        this.vm.supCreditAcc = new ItemViewModel1(f.supCreditAcc.id, f.supCreditAcc.name);
      }
      if (this.vm.purchaseDetail !== undefined && this.vm.purchaseDetail.length > 0) {
        this.vm.purchaseDetail.forEach(x => {
          //x.TotalAmount += x.Quantity * x.PurchasePrice;
          //this.selectedSpareParts.push(new ItemViewModel(x.FK_G_Item_Id.Id, x.FK_G_Item_Id.Name));
          let partssSelected = new SaveItemRequest();
          partssSelected.id = x.item.id;
          partssSelected.name = x.item.name;
          selectedSaprePartsList.push(partssSelected);
        });
        this.selectedSpareParts = selectedSaprePartsList;
        this.vatChanged();
        console.log(this.selectedPurchaseRequisitions);
      }
    }
    this.updateTotals();
  }

  onDeSelectPurchaseRequisition(e) {
    this.selectedSpareParts = [];
    this.selectedSuppliers = [];
    this.wareHouseList = this.whList;
    //let selectedSaprePartsList: any = [];
    // let f = this.purchaseRequisitions.find(x => x.Id == e.Id);
    // if (f !== undefined) {
    //   f.PurchaseDetail.forEach(x => {
    //     this.vm.PurchaseDetail.splice(this.vm.PurchaseDetail.indexOf(x),1);
    //   });
    // }
    // this.vm.PurchaseDetail.forEach(x=> {
    //   let partssSelected = new GItemDefiningViewModel();
    //           partssSelected.Id = x.FK_G_Item_Id.Id;
    //           partssSelected.Name = x.FK_G_Item_Id.Name;
    //           selectedSaprePartsList.push(partssSelected);
    // });
    // this.selectedSpareParts = selectedSaprePartsList;
    if (this.selectedPurchaseRequisitions.length == 0) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.transactionDate = new Date();
      this.getRefid();
      this.updateTotals();
    }
  }

  onRemoveFromDetailList(e) {
    this.selectedSpareParts = [];
    console.log(e);
    let i = this.vm.purchaseDetail.find(x => x.item.id === e.item.id);
    if (i !== undefined) {
      this.vm.purchaseDetail.splice(this.vm.purchaseDetail.indexOf(i), 1);
      this.vm.purchaseDetail.forEach(x => {
        this.selectedSpareParts.push(new ItemViewModel1(x.item.id, x.item.name));
      });
      if (this.vm.purchaseDetail.length == 0) {
        this.selectedPurchaseRequisitions = [];
        this.getRefid();
      }
    }

    this.getRequisitions();
  }


  // exteral coponents
  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._modalService.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }

  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }

  public itemType = new ItemViewModel1();
  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {

    if (model !== undefined) {
      this.sparePartVm = model;
    } else {
      this.sparePartVm = undefined;
    }
    this.openModal(template, 1);
    this.modalRef.setClass('modal-xl');
  }

  openSaveOrUpdateModelForItemType(template: TemplateRef<any>, model?, itemType?) {
    this.itemType = this.itemTypes[itemType];
    this.sparePartVm.itemType = new ItemViewModel1(this.itemType.id, this.itemType.name);
    console.log(this.itemTypes);
    this.openSaveOrUpdateModel(template, model);
  }



  saveOrUpdate() {
    // this._jq.showSpinner(true);
    debugger
    this.spinner.show();
    this.onChange(true);
    this.vm.statusType = new ItemViewModel1(E_G_EPSStatusType.Purchase_Slip)
    this._uow.gPurchaseService
      .SaveGPurchaseAsync(this.vm)
      .toPromise().then((res: any) => {
        debugger
        console.log(res);
        this.submitted = true;
        //this.vm = res;
        this.vm.isEmailRequired = true;
        this.bsmRef.hide();
        //this.modalRef.hide();
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
        Swal.fire(
          'Created!',
          'Created/Updated! Successfully',
          'success'
        )

        this.ngOnInit();
      })
      .catch((error) => {
        debugger
        Swal.fire(
          'Failure!',
          error.error.message,
          'error'
        )
        console.log(`Promise rejected with ${JSON.stringify(error)}`);
        this.onSubmitted.emit(this.submitted);
        this.spinner.hide();
      });
  }

  navigateClick() {
    this.isPreview = false;
    this.modalRef.hide()
  }

  // external components
  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {

    }
  }

  openPreview(content) {
    debugger
    this.modalRef = this._uow.modalServiceEx.show(content);
    this.modalRef.setClass('modal-lg');
    this.isPreview = true;
  }

   closeModal() {
    debugger
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }
}
